import { request } from "@/Api";
import { CustomBox, FlexCell, FlexRow } from "@/common/StyledComponents";
import {
    Autocomplete,
    Button,
    Chip,
    CircularProgress,
    Grid,
    Modal,
    TableCell,
    TextField,
    useTheme,
} from "@mui/material";
import { useEffect, useState } from "react";

import SendIcon from "@mui/icons-material/Send";
import { emailIsValid } from "@/utils";

export default function VendorInvitationsPopup({ onInvite }) {
    const theme = useTheme();
    const [isOpen, setIsOpen] = useState(false);
    const [vendors, setVendors] = useState([]);
    const [waiting, setWaiting] = useState(false);
    const handleInviteVendors = () => {
        setWaiting(true);
        request
            .post(`vendors/invite`, { vendor_emails: vendors })
            .then((response) => {
                setVendors([]);
                onInvite(response.data);
            })
            .finally(() => {
                setWaiting(false);
            });
    };
    const handleVendorsChange = (event, newValue) => {
        var lastValue = newValue[newValue.length - 1];
        if (emailIsValid(lastValue)) {
            setVendors(newValue);
        } else {
            setVendors(newValue.slice(0, newValue.length - 1));
        }
    };

    return (
        <>
            <Button
                startIcon={<SendIcon />}
                onClick={() => {
                    setIsOpen(true);
                }}
            >
                Invite Vendor
            </Button>
            <Modal
                open={isOpen}
                onClose={() => {
                    setIsOpen(false);
                }}
            >
                <CustomBox
                    sx={{
                        maxHeight: "90vh",
                        padding: 2,
                        paddingLeft: 4,
                        paddingRight: 4,
                        background: theme.palette.background.default,
                        overflow: "scroll",
                        width: "60%",
                        minWidth: 800,
                    }}
                >
                    <h3 style={{ marginBottom: 30 }}>Invite new vendors</h3>
                    <Autocomplete
                        onChange={handleVendorsChange}
                        value={vendors}
                        freeSolo
                        multiple
                        options={[]}
                        renderTags={(value, getTagProps) =>
                            value.map((email, index) => {
                                return (
                                    <Chip
                                        key={index}
                                        label={email}
                                        {...getTagProps({ index })}
                                        color="info"
                                    />
                                );
                            })
                        }
                        renderInput={(params) => (
                            <TextField
                                fullWidth
                                {...params}
                                label=""
                                InputLabelProps={{ shrink: false }}
                            />
                        )}
                    />
                    <Grid
                        container
                        alignItems={"center"}
                        justifyContent={"space-between"}
                        paddingTop={4}
                        paddingBottom={2}
                    >
                        <Grid item>
                            An invitation to join the selected vendor will be
                            sent to the above email addresses.
                        </Grid>
                        <Grid item>
                            <Grid container spacing={2}>
                                <Grid item>
                                    <Button
                                        variant="contained"
                                        color="secondary"
                                        onClick={() => {
                                            setIsOpen(false);
                                        }}
                                    >
                                        Cancel
                                    </Button>
                                </Grid>
                                <Grid item>
                                    {waiting ? (
                                        <CircularProgress />
                                    ) : (
                                        <Button
                                            variant="contained"
                                            onClick={handleInviteVendors}
                                        >
                                            Invite Vendors
                                        </Button>
                                    )}
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </CustomBox>
            </Modal>
        </>
    );
}
